import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { PostUserKYCPayload, PostUserKYCRespond } from './types/Kyc';

export type PutUserKYC = (
  userId: 'me' | number,
  kycUUID: string,
  data: Partial<PostUserKYCPayload>,
) => Promise<{ data: PostUserKYCRespond }>;

export default (makeCall: MakeCall): PutUserKYC => (userId, kycUUID, data) =>
  makeCall<PostUserKYCRespond>(
    'PUT',
    `${APIV2_URL}/user/${userId}/kyc/${kycUUID}`,
    {
      data,
    },
  );
